/* Chahal Agri Farms — Custom Interactions v18 */
(function () {
  'use strict';

  /* ── SCROLL REVEAL (hardened) ──
   * Sections fade in on scroll as a progressive enhancement. Earlier
   * versions set every section to opacity:0 and relied solely on an
   * IntersectionObserver to reveal them — on mobile Safari the observer
   * sometimes never fired (bfcache restore, slow hydration), leaving the
   * page blank until reloaded 2-3 times. The safety nets below guarantee
   * content is always shown.
   */
  var revealEls = [];
  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    revealEls.forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  function setupReveal() {
    /* No observer support or reduced motion: never hide anything. */
    if (prefersReduced || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.shopify-section').forEach(function (el) {
      if (el.closest('#header-group')) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.65s ease, transform 0.65s ease';
      revealEls.push(el);
      io.observe(el);
    });

    /* Safety net: force-reveal anything still hidden after 1.8s. */
    setTimeout(revealAll, 1800);
  }

  try {
    setupReveal();
  } catch (err) {
    revealAll();
  }

  /* bfcache restore (back/forward on mobile): inline opacity:0 can persist
     without the observer re-firing — force everything visible. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) revealAll();
  });

  /* ── HOVER LAB REPORT OVERLAY ON PRODUCT CARDS ──
   * Shows a dark forest green overlay with NABL info when a customer
   * hovers a product card. Disabled on touch devices via CSS
   * (chahal-mobile-fixes.css @media (hover: none)).
   */
  function addLabHoverOverlays() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.dataset.labOverlayAdded) return;
      card.dataset.labOverlayAdded = 'true';
      card.style.position = 'relative';

      var overlay = document.createElement('div');
      overlay.className = 'caf-lab-hover';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML = [
        '<div class="caf-lab-inner">',
        '<div class="caf-lab-shield">',
        '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C8922A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">',
        '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
        '<polyline points="9 12 11 14 15 10"/>',
        '</svg>',
        '</div>',
        '<div class="caf-lab-tag">NABL Lab Tested</div>',
        '<div class="caf-lab-lab">Equinox Labs, Navi Mumbai</div>',
        '<div class="caf-lab-result">',
        '<span class="caf-pass">&#x2713;</span> All Parameters Pass',
        '</div>',
        '<a href="/pages/lab-reports" class="caf-lab-link">View Lab Reports →</a>',
        '</div>'
      ].join('');

      var mediaEl = card.querySelector('.card__media, [class*="card__media"]');
      if (mediaEl) {
        mediaEl.style.position = 'relative';
        mediaEl.appendChild(overlay);
      } else {
        card.appendChild(overlay);
      }
    });
  }

  /* Run on load + after dynamic content loads (cart, filters etc) */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addLabHoverOverlays);
  } else {
    addLabHoverOverlays();
  }
  /* Re-run after 1.2s in case of lazy-loaded sections */
  setTimeout(addLabHoverOverlays, 1200);

})();

/* ── MOBILE FOOTER ACCORDIONS ──
 * The footer link columns (Products / Learn / Help) are hand-built from
 * group blocks (a heading text-block + individual link blocks), not the
 * theme's Menu block — so the native "Show as accordion" toggle does not
 * apply. On mobile each heading becomes tap-to-toggle and its links are
 * collapsed by default (tap to open). Desktop keeps the full columns:
 * every interaction is gated behind matchMedia, and the collapse styling
 * lives inside a max-width:749px block in chahal-mobile-fixes.css.
 */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 749px)');
  var HEADING_KEYS = ['_products_heading', '_learn_heading', '_help_heading'];
  var wired = false;

  function wireFooterAccordions() {
    if (wired) return;
    var found = 0;

    HEADING_KEYS.forEach(function (key) {
      var heading = document.querySelector('[class*="' + key + '"]');
      if (!heading) return;
      var column = heading.closest('.group-block-content');
      if (!column || column.dataset.cafFcol) return;

      column.dataset.cafFcol = '1';
      column.classList.add('caf-fcol');
      heading.classList.add('caf-fcol-head');
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-expanded', 'false');
      found++;

      function toggle() {
        var open = column.classList.toggle('caf-fcol-open');
        heading.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      heading.addEventListener('click', function (e) {
        if (!MOBILE.matches) return; /* desktop: columns stay open */
        e.preventDefault();
        toggle();
      });

      heading.addEventListener('keydown', function (e) {
        if (!MOBILE.matches) return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          toggle();
        }
      });
    });

    if (found) wired = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireFooterAccordions);
  } else {
    wireFooterAccordions();
  }
  /* Footer can hydrate late on mobile — retry a couple of times. */
  setTimeout(wireFooterAccordions, 1000);
  setTimeout(wireFooterAccordions, 2500);
})();
